import { ExcelWorkbook } from '../models/ExcelWorkbook';
import { ExcelWorksheet } from '../models/ExcelWorksheet';

export function createWorkbook(props: { orderedSheets: ExcelWorksheet[] }): ExcelWorkbook {
  const { orderedSheets } = props;

  return {
    SheetNames: orderedSheets.map(({ name }: ExcelWorksheet) => name),

    Sheets: orderedSheets.reduce((acc: Record<string, ExcelWorksheet>, sheet: ExcelWorksheet) => {
      if (sheet.name in acc) {
        throw new Error(
          `"${sheet.name}" is registered as sheet name more than once. Cannot have multiple sheets with the same name.`,
        );
      }

      acc[sheet.name] = sheet;

      return acc;
    }, {}),
  };
}
